'use strict';

import AWS from 'aws-sdk';
import moment from 'moment';

let RETRY_LOGIN_MAX_COUNT      = 3;

/**
 * Cognitoの認証情報をリクエスト
 * @param identityId
 * @param retryLoginCount
 */
function requestCognitoCredential(identityId, retryLoginCount){
  if(!retryLoginCount){
    retryLoginCount = 0;
  }
  
  return new Promise((resolve, reject)=>{
    let params = {
      IdentityPoolId: process.env.AWS_COGNITO_IDENTITY_POOL_ID
    };
    
    if(identityId){
      params.IdentityId = identityId;
    }
    
    AWS.config.credentials = new AWS.CognitoIdentityCredentials(params);
    
    // クレデンシャルゲッツ
    AWS.config.credentials.get((err)=>{
      if(err){
        // リトライする
        if(++retryLoginCount < RETRY_LOGIN_MAX_COUNT){
          setTimeout(()=>{
            requestCognitoCredential(identityId, retryLoginCount)
              .then((credentials)=>{
                resolve(credentials);
              })
              .catch((err)=>{
                reject(err);
              });
          }, 500);
        }else{
          reject(err);
        }
      }else{
        logger('Cognito Identify Id: ', AWS.config.credentials);
        resolve(AWS.config.credentials);
      }
    });
  });
}

export default {
  /**
   * CognitoのIdentityCredentialを取得
   * @returns {Promise}
   */
  initializeCognito(){
    // リージョンの初期化
    AWS.config.region = process.env.AWS_REGION;
    
    // Cognito初期化
    return requestCognitoCredential();
  },
  
  /**
   * 画像をS3にアップロードする
   * @param file
   * @param identityId
   * @param device
   * @param onUploadProgress
   */
  uploadImageToS3(file, identityId, device, onUploadProgress){
    return new Promise((resolve, reject)=>{
      // 拡張子を取得
      let ext = file.name.match(/(.*)(?:\.([^.]+$))/)[2];
      
      // 端末名
      let deviceName  = device.deviceName ? device.deviceName.replace(/ /g, '_').replace(/-/g, '_') : 'NO_DEVICE';
      let osName      = device.osName ? device.osName.replace(/ /g, '_').replace(/-/g, '_') : 'NO_OS';
      let browserName = device.browserName ? device.browserName.replace(/ /g, '_').replace(/-/g, '_') : 'NO_BROWSER';
      
      // アップロードするファイル名
      let fileName = moment().utc().format('YYYYMMDDHHmmss') + '-' + deviceName + '-' + osName + '-' + browserName + '.' + ext;
      
      // そのユーザ専用のパスに画像をアップロード
      let s3Client = new AWS.S3({params: {Bucket: process.env.S3_UPLOAD_BUCKET_NAME}});
      s3Client.putObject(
        {
          Key:         identityId + '/' + fileName,
          ContentType: file.type,
          Body:        file,
          ACL:         'public-read'
        },
        function(err, data){
          if(err){
            reject(err);
          }else if(!data){
            reject('No data');
          }else{
            resolve(fileName);
          }
        }
      ).on('httpUploadProgress', function(progress){
        if(onUploadProgress){
          onUploadProgress(Math.round(progress.loaded / progress.total * 100));
        }
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/store/api/aws-api.js